module.exports = "<h3>Ecco quanto vale il tuo cellulare</h3>\n\n<app-variant *ngIf=\"variant\" [variant]=\"variant\">\n  <app-sell-buttons></app-sell-buttons>\n</app-variant>\n\n<h3>Cellulari Suggeriti per te</h3>\n<!--<app-variant-list *ngIf=\"suggestedVariants\"  [variants]=\"suggestedVariants\"></app-variant-list>-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/variant-details/variant-details.component.html
// module id = 751
// module chunks = 1